import { Skeleton } from '@shared/components/shadcn';

function CategoryCard() {
  return (
    <div className="flex flex-col items-center justify-center p-4 border border-ui-200 rounded-md">
      <Skeleton className="size-8 rounded-full mb-2" />
      <Skeleton className="h-4 w-20" />
    </div>
  );
}

function SearchLoading() {
  return (
    <main className="ll-grid-container">
      <div className="ll-container-inner mb-10">
        <div className="mt-6">
          <Skeleton className="h-11 w-full rounded-full" />
        </div>

        <div className="mb-6 mt-8 flex items-center">
          <Skeleton className="h-6 w-28 mr-2" />
          <Skeleton className="h-5 w-6 rounded-md" />
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {Array.from({ length: 10 }).map((_, index) => (
            <CategoryCard key={index} />
          ))}
        </div>
      </div>
    </main>
  );
}

export { SearchLoading };
